import { HTMLAttributes } from "react";
import { clsx } from "clsx";
import styles from "./Spinner.module.css";

type SpinnerProps = {
  size?: "1" | "2";
  variant?: "light" | "dark";
} & HTMLAttributes<HTMLDivElement>;

export function Spinner({ size = "1", variant = "light", className, ...props }: SpinnerProps) {
  return (
    <div
      aria-hidden="true"
      className={clsx(styles.spinnerRoot, className)}
      data-size={size}
      data-variant={variant}
      {...props}
    />
  );
}
